export default {
    senderEmailData: []
}
